import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './js/LoginSystem/login';
import Reset from './js/LoginSystem/resetpwd';
import Organise from './js/AdminBoard/organise';
import SendEmail from './js/LoginSystem/send_email';
import Userboard from './js/UserBoard/userboard';
import VideoCallPage from './js/VideoCall/videoCall';
import ExtVideoCallPage from './js/VideoCall/ExtVideoCallPage';
import KonnektFormDisplay from './js/Konnekt/form_display';
import PrivateRoute from './js/Component/PrivateRoute';
import WifiReady from './js/PublicPages/WifiReady';
import AddContacts from './js/PublicPages/AddContacts';
import './App.css';
import AgoraRTC from 'agora-rtc-sdk-ng';
// import { DeviceProvider } from './js/DevicesContext';

// Remove AgoraRTC logger
AgoraRTC.setLogLevel(4);

function App() {
    return (

        <Router>
            <div>
                <Routes>
                    <Route exact path="/" element={<Login />} />
                    <Route path="/wifi-ready" element={<WifiReady />} />
                    <Route path="/add-contacts" element={<AddContacts />} />

                    <Route path="/reset" element={<Reset />} />
                    <Route path="/send_email" element={<SendEmail />} />

                    <Route path="/video-call" element={<VideoCallPage />} />
                    <Route path="/ext-video-call" element={<ExtVideoCallPage />} />

                    <Route path='/organise' element={<PrivateRoute> <Organise /> </PrivateRoute>} />
                    <Route path='/userboard/:orgGuid' element={<PrivateRoute> <Userboard /> </PrivateRoute>} />

                    <Route path='/konnekt-form' element={<KonnektFormDisplay />} />
                </Routes>
            </div>
        </Router>

    );
}

export default App;